import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Mantine's stylesheet MUST be imported before global.css: our design tokens and
// the Tailwind utility layer at the end of global.css are meant to WIN ties
// against Mantine's own `.m_*` rules and `:root[data-mantine-color-scheme=…]`
// variable blocks (e.g. the `--mantine-color-dimmed` bridge). Previously Mantine
// was imported from App.tsx — i.e. AFTER global.css — which silently inverted
// that contract.
import '@mantine/core/styles.css';
import './styles/global.css';
import App from './App';

/**
 * Forge entry point.
 *
 * Auth (amplify-js) initialization will land in Phase 2 — once the Cognito
 * user-pool / client IDs are emitted by `Forge-${stage}-Identity`, this file
 * imports `aws-amplify/auth` and calls `Amplify.configure(...)` here, before
 * React renders. The skeleton intentionally keeps render and bootstrap as
 * the only responsibilities of this file.
 */

// Stale-chunk resilience: after a redeploy, an already-open tab still points at
// old hashed chunk filenames that no longer exist in S3, so a lazy route import
// 404s ("Failed to fetch dynamically imported module"). Vite fires
// `vite:preloadError` for exactly this — reload once to pull the fresh
// index.html + current chunks instead of surfacing a broken screen. The
// sessionStorage guard prevents a reload loop if the failure is not transient.
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('forge-chunk-reloaded') === '1') return;
  sessionStorage.setItem('forge-chunk-reloaded', '1');
  window.location.reload();
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Forge: #root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
